import React, { useCallback, useEffect, useState } from 'react';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import { useMyAccount } from '../../../../../data/hooks/sessionHooks';
import Button from '../../../../elements/Button/Button';
import { dialogAlert } from '../../../../elements/Dialog/dialogs';
import Input from '../../../../elements/forms/Input';
import Link from '../../../../elements/Link';

const RequestOldPassword = (props) => {
    const { onChange, onIDontKnowPassword } = props,
        user = useMyAccount(),
        [oldPassword, setOldPassword] = useState(),
        [checkingPassword, setCheckingPassword] = useState(false),
        i18n = useI18n();

    const handleSubmit = useCallback(
        (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (oldPassword && !checkingPassword) {
                setCheckingPassword(true);
            }
        },
        [oldPassword]
    );

    useEffect(() => {
        if (checkingPassword) {
            let waiting = true;

            async function confirmPassword() {
                try {
                    let session = await app.api.session.confirmPassword(user.email, oldPassword);
                    if (waiting) onChange(oldPassword);
                } catch (err) {
                    if (err?.status == 401) {
                        if (err.response?.data?.error == 'password_reset') {
                            await dialogAlert(i18n['message.forgottenPasswordRecovered']);
                            app.history.replace('..');
                        } else {
                            document.querySelector('input[type=password]')?.select();
                            await dialogAlert(i18n['message.invalid-password']);
                        }
                    } else {
                        console.log('Other error', err);
                    }
                }
                if (waiting) setCheckingPassword(false);
            }
            confirmPassword();

            return () => (waiting = false);
        }
    }, [checkingPassword]);

    // NOTE: using autoComplete="one-time-code" to prevent browsers from offering to save a password that will stop being used

    return (
        <form onSubmit={handleSubmit}>
            <div className="indent content" style={{ minHeight: 200 }}>
                <Input
                    type="password"
                    label={i18n['message.change_password.enter_old']}
                    value={oldPassword}
                    onChange={setOldPassword}
                    autoFocus
                    name="old-password-input"
                    autoComplete="one-time-code"
                />
                <p>
                    <Link onClick={onIDontKnowPassword}>{i18n['button.dont_know_password']}</Link>
                </p>
            </div>
            <br />
            <div className="content">
                <Button type="submit" primary block>
                    {i18n['label.continue']}
                </Button>
            </div>
        </form>
    );
};

export default RequestOldPassword;
